import type { ReactNode } from 'react';

export const symbol_switch_video: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M250-453h300l-45 45q-8 7.82-8 19.91t7.86 20.09q7.85 8 20 8 12.14 0 20.14-8l94-94q5-5 7-10.13 2-5.14 2-11 0-5.87-2-10.87-2-5-7-10l-94-94q-7.82-8-19.91-8T505-598.14q-8 7.85-8 20 0 12.14 8 20.14l45 45H250l45-45q8-7.82 8-19.91T295.14-598q-7.85-8-20-8-12.14 0-20.14 8l-94 94q-5 5-7 10.13-2 5.14-2 11 0 5.87 2 10.87 2 5 7 10l94 94q7.82 8 19.91 8t20.09-7.86q8-7.85 8-20 0-12.14-8-20.14l-45-45ZM140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h520q24 0 42 18t18 42v215l134-134q7-7 16.5-3.46T880-649v338q0 9.92-9.5 13.46Q861-294 854-301L720-435v215q0 24-18 42t-42 18H140Zm0-60h520v-520H140v520Zm0 0v-520 520Z"
		/>
	</svg>
);
